import { render } from "./disposalInfo.vue?vue&type=template&id=612de4b3"
import script from "./disposalInfo.vue?vue&type=script&lang=js"
export * from "./disposalInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__